/* Back in Stock (Klaviyo) — "Powiadom mnie" on product cards.
   Event-delegated so it survives Symmetry's product-block re-renders. */
(function () {
  var COMPANY_ID = 'RyMcnW'; // Klaviyo public API key (site ID)
  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + COMPANY_ID;
  var REVISION = '2024-10-15';

  function isEmail(v) {
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v);
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('.bis-card__toggle');
    if (!toggle) return;
    e.preventDefault();
    var card = toggle.closest('.bis-card');
    var form = card && card.querySelector('.bis-card__form');
    if (!form) return;
    toggle.hidden = true;
    form.hidden = false;
    var input = form.querySelector('.bis-card__email');
    if (input) input.focus();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.bis-card__form');
    if (!form) return;
    e.preventDefault();

    var card = form.closest('.bis-card');
    var variantId = card && card.getAttribute('data-variant-id');
    var input = form.querySelector('.bis-card__email');
    var msg = form.querySelector('.bis-card__msg');
    var submit = form.querySelector('.bis-card__submit');
    var email = input && input.value ? input.value.trim() : '';

    if (!isEmail(email)) {
      if (msg) msg.textContent = 'Podaj poprawny adres e-mail.';
      return;
    }
    if (!variantId) {
      if (msg) msg.textContent = 'Brak danych produktu. Odśwież stronę.';
      return;
    }

    if (submit) submit.disabled = true;
    if (msg) msg.textContent = 'Zapisuję…';

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
        }
      }
    };

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (res.ok || res.status === 202) {
          form.innerHTML =
            '<p class="bis-card__msg bis-card__msg--ok">Damy znać mailowo, gdy produkt wróci do sprzedaży.</p>';
        } else {
          return res.text().then(function (t) {
            throw new Error(t || String(res.status));
          });
        }
      })
      .catch(function (err) {
        if (submit) submit.disabled = false;
        // A TypeError here usually means the request to klaviyo.com was blocked
        // (ad blocker / privacy extension / cookie-consent gate) rather than a real failure.
        if (msg) {
          msg.textContent =
            err && err.name === 'TypeError'
              ? 'Zapis zablokowany przez przeglądarkę (bloker reklam / zgody). Wyłącz blokowanie i spróbuj ponownie.'
              : 'Coś poszło nie tak. Spróbuj ponownie.';
        }
      });
  });
})();
